import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store.js";
import { ToastContainer } from "react-toastify";
import { PrimeReactProvider } from 'primereact/api';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App.jsx";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <ToastContainer />
      <PrimeReactProvider>
        <App />
        </PrimeReactProvider>
      </PersistGate>
    </Provider>
);
